module.exports = __webpack_public_path__ + "img/8Z2.ce066395.png";